import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-local-road-signpost',
    templateUrl: './aa-local-road-signpost.component.html',
    styleUrls: ['./aa-local-road-signpost.component.scss'],
    standalone: false
})
export class AaLocalRoadSignpostComponent {

  @Input() road: Array<Road>;

  constructor() { }

  get roads() {
    return this.road;
  }

  getClassName(name) {
    return (name.indexOf('M') !== -1) ? 'signspot-motorway' : 'signspot-a-road';
  }
  trackByFn(index: number): number {
    return index;
  }
}
